/**
 * Ligações «clique para conversar» do WhatsApp (wa.me), para mensagens enviadas
 * à mão a partir do sistema — sem API nem gateway (docs/16-PARCEIROS-WHATSAPP.md).
 */
/**
 * Número moçambicano no formato do wa.me: 258 + 9 algarismos (82–87).
 * Aceita «84 123 4567», «+258 84 123 4567», «00258841234567», «258841234567».
 * Devolve null se não for um número móvel moçambicano.
 */
export function mzWhatsappNumber(raw) {
    if (!raw)
        return null;
    const d = raw.replace(/\D/g, '').replace(/^00/, '');
    const local = d.startsWith('258') && d.length === 12 ? d.slice(3) : d;
    return /^8[2-7]\d{7}$/.test(local) ? `258${local}` : null;
}
/** https://wa.me/<número>?text=<mensagem>; sem número válido devolve null. */
export function waMe(phone, text) {
    const n = mzWhatsappNumber(phone);
    if (!n)
        return null;
    return `https://wa.me/${n}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
}
//# sourceMappingURL=whatsapp.js.map